import { render, staticRenderFns } from "./Educacional.vue?vue&type=template&id=7911bc5a&scoped=true&"
import script from "./Educacional.vue?vue&type=script&lang=js&"
export * from "./Educacional.vue?vue&type=script&lang=js&"
import style0 from "./Educacional.vue?vue&type=style&index=0&id=7911bc5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7911bc5a",
  null
  
)

export default component.exports